import { render, staticRenderFns } from "./CurriculumTopField.vue?vue&type=template&id=8255403c&scoped=true&lang=pug"
import script from "./CurriculumTopField.vue?vue&type=script&lang=js"
export * from "./CurriculumTopField.vue?vue&type=script&lang=js"
import style0 from "./CurriculumTopField.vue?vue&type=style&index=0&id=8255403c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8255403c",
  null
  
)

export default component.exports